export default __webpack_public_path__ + "static/media/modal_new_exercise.a1750ad4.png";